<template>
    <div>
        <div class="login-box" id="login-box">
            <div class="login-body">
                <h3 class="popup-title mb-1">{{ $t('login') }}</h3>
                <form id="create_form" method="POST" encType="multipart/form-data" @submit.prevent="onSubmit" style="max-width: 300px;margin: auto;">
                    <div class="form-group">
                        <input type="text" :class="error.field_username ? 'ito-input has-err' : 'ito-input'" name="username" :placeholder="$t('id_email_phone_number')" autocomplete="off" v-model="user.username" />
                        <div class="error-message text-start" v-if="error.field_username">{{ error.field_username }}</div>
                    </div>
                    <div class="form-group">
                        <input :type="showPass ? 'text' : 'password'" id="login-password-field" name="password" :class="error.field_password ? 'ito-input has-err' : 'ito-input'" :placeholder="$t('password')" v-model="user.password" />
                        <span :class="[showPass ? 'icon-eye eye-show' : 'icon-eye eye-hide']" @click="showPass = !showPass"></span>
                        <div class="error-message text-start" v-if="error.field_password">{{ error.field_password }}</div>

                    </div>

                    <router-link :to="{ name: 'forgot_password' }" class="forgot-link link-underline mb-1 mt-3">{{ $t('you_ve_forgot_password') }}</router-link>

                    <div class="form-group" style="margin-top: 30px; margin-bottom: 10px">
                        <button type="submit" class="ito-btn-large mt-3">{{ $t('login') }}</button>

                        <login-google />

                        <div class="error-message text-center" v-if="error.message">{{ error.message }}</div>
                    </div>

                    <div class="links text-center">
                        <span>{{ $t('first_time_on_ito') }}</span>
                        <router-link class="link-underline register-link" :to="{ name: 'register' }">
                            {{ $t('create_an_account') }}
                        </router-link>
                    </div>
                </form>
            </div>
            <!-- <div class="login-bottom">
                <span>Học thử miễn phí mà không cần tạo tài khoản. </span><a href="/register-anomynous">Try now</a>
            </div> -->
        </div>

        <div id="app-login">
            <div class="app-login-title">{{ $t('download_app_title') }}</div>
            <div class="app-login-desc">{{ $t('download_app') }}</div>
            <div class="app-login-download">
                <div class="app-login-android">
                    <div>
                        <a href="https://play.google.com/store/apps/details?id=ismart.edu.vn.ipro" target="_blank">
                            <img src="/themes/ito/images/qr-android.svg" class="app-login-qr" alt="">
                        </a>
                    </div>
                    <div>
                        <a href="https://play.google.com/store/apps/details?id=ismart.edu.vn.ipro" target="_blank">
                            <img src="/themes/ito/images/download-android.svg" alt="">
                        </a>
                    </div>
                </div>
                <div class="app-login-ios">
                    <div>
                        <a href="https://apps.apple.com/us/app/ismart-pro/id6448867836" target="_blank">
                            <img src="/themes/ito/images/qr-ios.svg" class="app-login-qr" alt="">
                        </a>
                    </div>
                    <div>
                        <a href="https://apps.apple.com/us/app/ismart-pro/id6448867836" target="_blank">
                            <img src="/themes/ito/images/download-ios.svg" alt="">
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="chooseAccount" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header justify-content-center border-0 p-3">
                        <h5 class="modal-title" id="staticBackdropLabel">{{ $t('choose_your_account ') }}</h5>
                        <div class="close-popup" data-bs-dismiss="modal"></div>
                    </div>
                    <div class="modal-body p-0">
                        <div class="form-check" v-for="student in students">
                            <input class="form-check-input" v-model="studentId" :value="student.id" type="radio" name="account">
                            <label class="form-check-label" for="account1">
                                {{ student.username }} _ {{ student.full_name }} _ {{ $t('grade') }} {{ student.grade }}
                            </label>
                        </div>

                    </div>
                    <div class="modal-footer justify-content-center border-0 p-3">
                        <button type="button" :disabled="studentId == ''" class="ito-btn ito-btn-primary ito-btn-block w-50" @click="onSubmit2()">Login</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
import { authLogin } from '../../models/auth'
import LoginGoogle from './LoginGoogle.vue';
import { updateLanguage } from '../../models/profile';

export default {
    name: "Login",
    components: { LoginGoogle },
    data() {
        return {
            studentId: "",
            students: [],
            error: {
                message: '',
                field_username: '',
                field_password: ''
            },
            user: {
                username: '',
                password: ''
            },
            showPass: false,
            step: 1,
        };
    },

    created() {
        this.fetch();
    },
    mounted() {

    },
    computed: {
        setAlert() {
            return this.$store.state.setAlert;
        },
        configs() {
            const configs = this.$store.getters.configs;
            return configs;
        },
    },

    methods: {
        fetch() {
            localStorage['is_login'] = false;
            localStorage.removeItem('access_token');
            localStorage.removeItem('grade');
            localStorage.removeItem('student');
            localStorage.removeItem('program');
        },
        onSubmit2() {
            let user = this.students.filter(e => e.id == this.studentId)
            const username = user[0].username;
            const password = this.user.password;
            this.login({ username, password });
        },
        onSubmit(e) {
            this.resetErrorsValid();
            if (!this.user.username) {
                this.error.field_username = this.$i18n.t('username_cannot_be_empty');
            }

            if (!this.user.password) {
                this.error.field_password = this.$i18n.t('password_cannot_be_empty');
            }

            if (this.error.field_username != '' || this.error.field_password != '') {
                return false;
            }
            else {
                const username = this.user.username;
                const password = this.user.password;
                this.login({ username, password });
                e.preventDefault();
            }
        },

        resetErrorsValid() {
            this.error = {
                message: '',
                field_username: '',
                field_password: ''
            }
        },

        async login(user) {
            const that = this;
            that.$store.commit("setLoading", true);

            try {
                const response = await authLogin(user);
                that.$store.commit("setLoading", false);

                // Chuẩn hoá: kiểm tra code trả về
                const { code, error_code, student_info, results } = response?.data || {};

                if (code !== 0) {
                    if (code === 1) {
                        // Lấy câu thông báo i18n, fallback nếu không tìm thấy
                        const msg = this.$i18n.te(error_code) ? this.$i18n.t(error_code) : this.$i18n.t('has_error');
                        this.error.message = msg;
                        return false;
                    } else {
                        // Trường hợp nhiều tài khoản
                        this.studentId = "";
                        this.students = Array.isArray(student_info) ? student_info : [];
                        // Hiển thị modal chọn tài khoản
                        $('#chooseAccount').modal("show");
                        return false;
                    }
                }

                // Đăng nhập thành công
                that.$store.commit('setAuth', true);

                if (results?.access_token) {
                    localStorage.setItem('access_token', results.access_token);
                }

                const leftCorner = document.querySelector("#left-corner");
                const rightCorner = document.querySelector("#right-corner");
                leftCorner?.classList.add('hide');
                rightCorner?.classList.add('hide');

                // Cập nhật ngôn ngữ & điều hướng
                await this.updateLocate();
            } catch (err) {
                // err có thể là Axios error; destructuring an toàn
                const axiosResponse = err?.response;
                this.$store.commit('setAuth', false);
                that.$store.commit("setLoading", false);
                this.error.message = this.$i18n.t('has_error');
                console.error('Login error:', axiosResponse || err);
            }
        },

        async updateLocate() {
            try {
                const langInStorage = localStorage.getItem('lang'); // có thể là null
                const configsRaw = localStorage.getItem('configs');
                const configs = configsRaw ? JSON.parse(configsRaw) : {};

                const localize = Array.isArray(configs.localize) ? configs.localize : [];

                let currentLang = null;

                if (langInStorage) {
                    currentLang = localize.find(item => item.lang === langInStorage) || null;
                }
                if (!currentLang && localize.length > 0) {
                    currentLang = localize[0];
                    localStorage.setItem('lang', currentLang.lang);
                }

                if (!currentLang || !currentLang.id) {
                    console.warn('Không tìm thấy cấu hình ngôn ngữ hợp lệ trong configs.localize');
                    return;
                }

                // Gọi API updateLanguage
                const resp = await updateLanguage({
                    id: currentLang.id,
                    is_raw: true
                });

                const { code } = resp?.data || {};
                if (code !== 0) {
                    // Không redirect nếu cập nhật thất bại
                    return;
                }
                this.$router.replace('/');
            } catch (err) {
                console.error('updateLocate error:', err?.response || err);
            }
        },

        // loginWithGoogle() {
        //     alert('Login with Google');
        // }
    }
}
</script>

<style scoped>
.form-group {
    position: relative;
}

.ito-input {
    width: 100%;
}

#login-box {
    position: relative;
    width: 550px;
    background: #ffffff;
    margin: auto;
    padding: 20px;
    text-align: center;
    box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07), inset 0px 4px 0px rgba(231, 231, 231, 0.25);
    border-radius: 8px;
}

#login-box .form-group {
    position: relative;
    max-width: 300px;
}

.forgot-password-popup {
    max-width: 550px;
    width: 550px;
}

.forgot-password-popup .modal-content {
    box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07), inset 0px 4px 0px rgba(231, 231, 231, 0.25);
    border-radius: 8px;
}
</style>